define( function() {
	"use strict";

	return window.location;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/ajax/var/location.js
// module id = 316
// module chunks = 0